var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpersonate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45984 3.5H18.5402C19.206 3.49999 19.7656 3.49997 20.2234 3.53738C20.7022 3.5765 21.1571 3.66144 21.589 3.88148C22.2475 4.21704 22.783 4.75247 23.1185 5.41103C23.3386 5.84289 23.4235 6.29785 23.4626 6.77657C23.5 7.23444 23.5 7.79396 23.5 8.45982V15.5402C23.5 16.206 23.5 16.7656 23.4626 17.2234C23.4235 17.7021 23.3386 18.1571 23.1185 18.589C22.783 19.2475 22.2475 19.783 21.589 20.1185C21.1571 20.3386 20.7022 20.4235 20.2234 20.4626C19.7656 20.5 19.206 20.5 18.5402 20.5H5.45982C4.79396 20.5 4.23444 20.5 3.77657 20.4626C3.29785 20.4235 2.84289 20.3386 2.41103 20.1185C1.75247 19.783 1.21704 19.2475 0.881478 18.589C0.661436 18.1571 0.576496 17.7021 0.537383 17.2234C0.499973 16.7656 0.499986 16.206 0.500001 15.5402V8.45984C0.499986 7.79397 0.499973 7.23445 0.537383 6.77657C0.576496 6.29785 0.661436 5.84289 0.881478 5.41103C1.21704 4.75247 1.75247 4.21704 2.41103 3.88148C2.84289 3.66144 3.29785 3.5765 3.77657 3.53738C4.23445 3.49997 4.79397 3.49999 5.45984 3.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.4C4 10.5599 4 10.1399 4.16349 9.81901C4.3073 9.53677 4.53677 9.3073 4.81901 9.16349C5.13988 9 5.55992 9 6.4 9H7.6C8.44008 9 8.86012 9 9.18099 9.16349C9.46323 9.3073 9.6927 9.53677 9.83651 9.81901C10 10.1399 10 10.5599 10 11.4V12.6C10 13.4401 10 13.8601 9.83651 14.181C9.6927 14.4632 9.46323 14.6927 9.18099 14.8365C8.86012 15 8.44008 15 7.6 15H6.4C5.55992 15 5.13988 15 4.81901 14.8365C4.53677 14.6927 4.3073 14.4632 4.16349 14.181C4 13.8601 4 13.4401 4 12.6V11.4Z",
    fill: "white",
    stroke: "#1E57C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H19",
    stroke: "#1E57C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H17",
    stroke: "#1E57C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpersonate);
export default __webpack_public_path__ + "static/media/impersonate.a7e8bca59188b05b16a1e1d899095127.svg";
export { ForwardRef as ReactComponent };